import { Address, AddressStatusType } from "./Address";

export type LocationRequestResponse = {
  lat: number;
  lon: number;
  time?: string;
};

export enum UserLocationRequestType {
  Default = "DEFAULT",
  RequestLatLng = "REQUEST_LAT_LNG",
  RequestGeoAddress = "REQUEST_GEO_ADDRESS",
  RequestLatLngAndGeoAddress = "REQUEST_LAT_LNG_AND_GEO_ADDRESS",
}

export type LastLocationResponse = {
  status: AddressStatusType;
  data: Address;
};

export type UserLocationData = {
  status: AddressStatusType;
  coords: LocationRequestResponse;
  data: Address;
  defaultLocation?: Address;
  isLastKnownLocation?: boolean;
};

export enum UserLocationRequirementType {
  Mandatory = "LOCATION_MANDATORY",
  Optional = "LOCATION_SHOW_NO_NUDGE_TO_USER",
  NotRequired = "LOCATION_NOT_REQUIRED",
}

export enum UserLocationType {
  Current = "current",
  Last = "last",
}

export enum UserGeoAddressType {
  Current = "current",
  LatLng = "lat-lon",
}

export type UserLocation = {
  requestType: UserLocationRequestType;
  isIntimatedOnUserAction?: boolean;
  payload: {
    locationType?: UserLocationType;
    geoAddressType?: UserGeoAddressType;
    givenLatLng?: LocationRequestResponse;
    locationRequirementType: UserLocationRequirementType;
    useCurrentLocOnly?: boolean;
  };
  bottomSheetData?: {
    title?: string;
    subtitle?: string;
    description?: string;
  };
};
